// Copyright (c) 2017 Deere & Company

export default [
    {
        displayName: 'ACCOUNT',
        path: ['responsibleAccount', 'account']
    },
    {
        displayName: 'CITY',
        path: ['responsibleAccount', 'location', 'city']
    },
    {
        displayName: 'STATE',
        path: ['responsibleAccount', 'location', 'state']
    }
];




// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/constants/sort-options.js